// © 2026 Buddy Media LLC. All rights reserved.
import type { ReactNode } from "react";

export type AdminPageShellProps = {
  /** Page title. Optional — falls back to "Admin" if the original
   * page relied on nav-config for the title (which this lean shell
   * doesn't have). Each migrated page should set this explicitly. */
  title?: string;
  description?: string;
  actions?: ReactNode;
  children: ReactNode;
};

export function AdminPageShell({
  title,
  description,
  actions,
  children,
}: AdminPageShellProps) {
  return (
    <div className="space-y-6">
      <header className="flex items-start justify-between gap-4">
        <div>
          {title && (
            <h1
              className="bg-clip-text text-2xl font-bold text-transparent"
              style={{
                backgroundImage:
                  "linear-gradient(135deg, #ffffff 0%, #c7d2fe 60%, var(--brand-accent) 100%)",
              }}
            >
              {title}
            </h1>
          )}
          {description && (
            <p className="mt-1 text-sm text-slate-400">{description}</p>
          )}
        </div>
        {actions && <div className="shrink-0">{actions}</div>}
      </header>
      <div>{children}</div>
    </div>
  );
}
